'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @function ignoreError
  * Helper function to ignore errors from promise
  * violations in play() and pause()
  */
function ignoreError() {}

/** @class BackgroundNoise
  * A component for playing background noise
  * in a virutal expo.  Only one such component
  * needs to be loaded into the app; doing so
  * adds the backgroundNoise api to the global
  * vexpo object.
  */

var BackgroundNoise = function (_Component) {
  _inherits(BackgroundNoise, _Component);

  /** @constructor
    * Initializes a new BackgroundNoise instance.
    */
  function BackgroundNoise(props) {
    _classCallCheck(this, BackgroundNoise);

    var _this = _possibleConstructorReturn(this, (BackgroundNoise.__proto__ || Object.getPrototypeOf(BackgroundNoise)).call(this, props));

    _this.audio = new window.Audio();
    _this.audio.loop = true;
    _this.audio.volume = props.volume;
    return _this;
  }
  /** @method componentWillMount
    * Creates an audio element to play background
    * noise and adds the backgroundNoise api to the
    * global vexpo object.
    */


  _createClass(BackgroundNoise, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.src) {
        this.audio.src = this.props.src;
        // Depending on the browser, play()
        // may throw an error or return a promise;
        // we need to deal with either situation.
        try {
          if (!this.props.mute) {
            var promise = this.audio.play();
            if (promise) {
              promise.catch(function (err) {
                console.error(err);
              });
            }
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
    /** @method componentWillUnmount
      * Stops any playing audio as the component is unmounted.
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Depending on the browser, pause()
      // may throw an error or return a promise;
      // we need to deal with either situation.
      try {
        var promise = this.audio.pause();
        if (promise) promise.catch(function (err) {
          console.error(err);
        });
      } catch (err) {
        console.error(err);
      }
    }
    /** @method componentWillReceiveProps
      * Adjusts the volume and responds to new source urls.
      */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.src != this.props.src) this.audio.src = newProps.src;
      this.audio.volume = newProps.volume;
      // Depending on the browser, play() and pause()
      // may throw an error or return a promise;
      // we need to deal with either situation.
      try {
        var promise;
        if (newProps.mute) promise = this.audio.pause();else promise = this.audio.play();
        if (promise) promise.catch(function (err) {
          console.error(err);
        });
      } catch (err) {
        console.error(err);
      }
    }
    /** @method render
      * Renders the background noise element.
      */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return BackgroundNoise;
}(_react.Component);

exports.default = BackgroundNoise;


BackgroundNoise.propTypes = {
  src: _propTypes2.default.string,
  volume: _propTypes2.default.number.isRequired,
  mute: _propTypes2.default.bool.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/sound/background-noise.js
// module id = 683
// module chunks = 0